(function () {
    const STORAGE_KEY = 'preferred_language';
    if (localStorage.getItem(STORAGE_KEY)) {
        return;
    }

    const language = navigator.language.substring(0, 2).toLowerCase();
    let targetLanguage = 'en';

    if (language == 'de') {
        targetLanguage = 'de'; 
    } else if (language == 'fr') {
        targetLanguage = 'fr'; 
    } else if (language == 'it') {
        targetLanguage = 'it'; 
    } else if (language == 'es') {
        targetLanguage = 'es'; 
    }

    if( targetLanguage == 'en'){
        return ;
    }

    localStorage.setItem(STORAGE_KEY, targetLanguage);

    const path = window.location.pathname.replace(/^\/(en|de|fr|nl)/, '');

    window.location.href = `/${targetLanguage}${path}${window.location.search}${window.location.hash}`;
})();